module.exports = __webpack_public_path__ + "img/MotherVessel2.859b9cf9.png";